import { Component, OnChanges, SimpleChanges, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';

import { Campaign } from '../campaign.model';
import { CampaignService } from '../campaign.service';

declare var $: any;

@Component({
  selector: 'wm-campaign-menu',
  template: require('./campaign-menu.component.html')
})
export class CampaignMenuComponent implements OnChanges {
  @Input() campaign: Campaign;
  @Input() metrics: string;

  active: string;
  actives: string[] = ['statistics', 'clicks', 'views', 'payments'];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: CampaignService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    this.active = this.metrics;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/campaigns/components/campaign-menu.component.ts